var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{attrs:{"editing-object":this.ItalyConfig,"is-dialog":false,"schema":this.schemas},on:{"submit":_vm.saveConfig}},[_c('page-header',[_vm._v("Italy Config")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }